import { array, boolean, nativeEnum, number, object, string, z } from 'zod';

import {
  AwardVouchersWithExpirationDaysSchema,
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
  ProductGroupSchema,
  ScanDataConfigurationSchema,
} from '@occc/validation';
import { requiresActivationConstraintSchema } from '@occc/feat-constraints';
import {
  minimumPurchaseConstraintsSchema,
  PaymentMethodConstraintSchema,
} from '@occc/feat-constraints/schemas';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';

import { SweepstakesAwardCountSchema } from './award-count.schema';

const PartialProductPurchaseSchema = object({
  purchaseThreshold: number().optional(),
  eligibleProductGroups: array(ProductGroupSchema).optional(),
  countProductsBy: nativeEnum(Earning_Mechanism_Product_Counting_Attribute).optional(),
});

const StayVisibleWhileInProgressSchema = object({ isEnabled: boolean() });

export const BaseSweepstakesSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  earningMechanism: object({ id: string().optional() }).optional(),
  awardVouchers: AwardVouchersWithExpirationDaysSchema,
  awardCount: SweepstakesAwardCountSchema,
  activation: requiresActivationConstraintSchema,
  paymentMethodConstraint: PaymentMethodConstraintSchema,
  minimumPurchaseConstraints: minimumPurchaseConstraintsSchema,
  customData: CustomDataSchema,
  scanDataConfiguration: ScanDataConfigurationSchema.optional(),
  productPurchase: PartialProductPurchaseSchema.optional(),
  productChallenge: object({
    products: array(PartialProductPurchaseSchema).optional(),
    earningMechanism: z.enum(['varietyPurchase', 'varietyPurchaseOverTime']).optional(),
    stayVisibleWhileInProgress: StayVisibleWhileInProgressSchema.optional(),
  }).optional(),
  spendBonus: object({
    accumulationThreshold: number().optional(),
    ineligibleProductGroups: array(ProductGroupSchema).optional(),
    stayVisibleWhileInProgress: StayVisibleWhileInProgressSchema.optional(),
  }).optional(),
  pointSpend: object({ pointCost: number().optional() }).optional(),
});
